@for (grid of [0, 1]; track grid) {
    <div class="sk-grid-first sk-p-12">
        <div class="sk-grid-evets">
            <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
            @for (i of [0, 1]; track i) {
                <div class="sk-grid-lines sk-h-12 sk-b-rad8"></div>
            }
        </div>
        <div class="sk-grid-markets">
            <div class="sk-grid-left">
                @for (team of teams; track $index) {
                    <div class="sk-grid-teams">
                        <div class="sk-grid-{{ team.team1 }} sk-h-12 sk-b-rad8"></div>
                        <div class="sk-grid-{{ team.team2 }} sk-h-12 sk-b-rad8"></div>
                    </div>
                }
                @if (isMobileOrRacingForecast) {
                    <div class="sk-grid-teams">
                        <div class="sk-grid-team3 sk-h-12 sk-b-rad8"></div>
                        <div class="sk-grid-team4 sk-h-12 sk-b-rad8"></div>
                    </div>
                }
            </div>
            <div class="sk-grid-right">
                @for (i of [0, 1, 2, 3]; track i) {
                    <div class="sk-grid-right-team sk-b-rad4"></div>
                }
                @if (isMobileOrRacingForecast) {
                    <div class="sk-grid-right-team sk-b-rad4"></div>
                }
            </div>
        </div>
    </div>
}
